var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "org-tree-layout" },
      [
        _c("swb-popover-org-tree", {
          attrs: {
            showMgmt: true,
            mgmtOnlyOrg: true,
            showIncludeSubComs: false,
            initIncludeSubComs: false,
            bizDepart: true
          },
          on: {
            "notity-change": function($event) {
              _vm.checkComCatChange($event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.channelCode == "bizParamComn"
      ? _c("div", { staticClass: "simple-form" }, [
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.comInfo.postOrgEnabled,
                      callback: function($$v) {
                        _vm.$set(_vm.comInfo, "postOrgEnabled", $$v)
                      },
                      expression: "comInfo.postOrgEnabled"
                    }
                  },
                  [
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: false } },
                      [_vm._v("否")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: true } },
                      [_vm._v("是")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-group center",
              staticStyle: { display: "none" }
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.comInfo.postRegionEnabled,
                        callback: function($$v) {
                          _vm.$set(_vm.comInfo, "postRegionEnabled", $$v)
                        },
                        expression: "comInfo.postRegionEnabled"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: false } },
                        [_vm._v("否")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: true } },
                        [_vm._v("是")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { disabled: _vm.comInfo.postDevcGrpEnabled },
                    model: {
                      value: _vm.comInfo.postGoodsCatEnabled,
                      callback: function($$v) {
                        _vm.$set(_vm.comInfo, "postGoodsCatEnabled", $$v)
                      },
                      expression: "comInfo.postGoodsCatEnabled"
                    }
                  },
                  [
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: false } },
                      [_vm._v("否")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: true } },
                      [_vm._v("是")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "input-tip error" }, [
                  _vm._v("【岗位商品分类】与【设备分类分组】只能开启一个")
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { disabled: _vm.comInfo.postGoodsCatEnabled },
                    model: {
                      value: _vm.comInfo.postDevcGrpEnabled,
                      callback: function($$v) {
                        _vm.$set(_vm.comInfo, "postDevcGrpEnabled", $$v)
                      },
                      expression: "comInfo.postDevcGrpEnabled"
                    }
                  },
                  [
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: false } },
                      [_vm._v("否")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: true } },
                      [_vm._v("是")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(4),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.comInfo.postMgmtAreaEnabled,
                      callback: function($$v) {
                        _vm.$set(_vm.comInfo, "postMgmtAreaEnabled", $$v)
                      },
                      expression: "comInfo.postMgmtAreaEnabled"
                    }
                  },
                  [
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: false } },
                      [_vm._v("否")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: true } },
                      [_vm._v("是")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          !_vm.comInfo.shopFlag
            ? _c("div", { staticClass: "form-group center" }, [
                _vm._m(5),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.comInfo.postSubShopTagFilterEnabled,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.comInfo,
                              "postSubShopTagFilterEnabled",
                              $$v
                            )
                          },
                          expression: "comInfo.postSubShopTagFilterEnabled"
                        }
                      },
                      [
                        _c(
                          "el-radio",
                          { staticClass: "radio", attrs: { label: false } },
                          [_vm._v("否")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          { staticClass: "radio", attrs: { label: true } },
                          [_vm._v("是")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.channelCode == "bizParamRepair"
      ? _c("div", { staticClass: "simple-form" }, [
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(6),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c("el-input", {
                  staticClass: "width-1-5x bottom-line",
                  attrs: { disabled: true },
                  model: {
                    value: _vm.comInfo.patrolGuardStaffName,
                    callback: function($$v) {
                      _vm.$set(_vm.comInfo, "patrolGuardStaffName", $$v)
                    },
                    expression: "comInfo.patrolGuardStaffName"
                  }
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass:
                    "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                  on: { click: _vm.selectStaffName }
                }),
                _vm._v(" "),
                _vm.comInfo.patrolGuardStaffId
                  ? _c(
                      "i",
                      {
                        staticClass: "input-deletable",
                        staticStyle: { right: "18px" },
                        on: { click: _vm.deleteStaffName }
                      },
                      [_vm._v("×")]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(7),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.comInfo.assistRepairRequestAllowed,
                      callback: function($$v) {
                        _vm.$set(_vm.comInfo, "assistRepairRequestAllowed", $$v)
                      },
                      expression: "comInfo.assistRepairRequestAllowed"
                    }
                  },
                  [
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: false } },
                      [_vm._v("否")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      { staticClass: "radio", attrs: { label: true } },
                      [_vm._v("是")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.comInfo.assistRepairRequestAllowed
            ? _c("div", { staticClass: "form-group center" }, [
                _vm._m(8),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { disabled: true },
                      model: {
                        value: _vm.comInfo.defRepairStaffName,
                        callback: function($$v) {
                          _vm.$set(_vm.comInfo, "defRepairStaffName", $$v)
                        },
                        expression: "comInfo.defRepairStaffName"
                      }
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass:
                        "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                      on: { click: _vm.selectDefStaffName }
                    }),
                    _vm._v(" "),
                    _vm.comInfo.defRepairStaffId
                      ? _c(
                          "i",
                          {
                            staticClass: "input-deletable",
                            staticStyle: { right: "18px" },
                            on: { click: _vm.deleteDefStaffName }
                          },
                          [_vm._v("×")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "form-label" }),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c(
            "button",
            {
              staticClass: "swb-btn swb-btn-small",
              attrs: { id: "saveBtn" },
              on: {
                click: function($event) {
                  _vm.submitForm()
                }
              }
            },
            [_vm._v("保存")]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("开启岗位组织")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("开启岗位地区")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("开启岗位商品分类")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("开启设备分类分组")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("开启岗位管理区域")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("开启下级机构标签")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("区域报修人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("小助手是否可报修")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("默认提报人")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-381da05c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-381da05c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/bizParam/OrgBizParamList.vue
// module id = 3677
// module chunks = 0